export default __webpack_public_path__ + "static/gemHomePage-4eb2645cdefff6cc2b04bd0a0c048f49.webp";